// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3MeYW","container":"styles_container__1gBKM","title":"styles_title__393Kv","wrapper":"styles_wrapper__Le_xO","answer":"styles_answer__50adY"};